module.exports = __webpack_public_path__ + "img/3-sdg-full@2x.b9f5c35c.png";